// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"87a61967","739":"be3b7b2d"}[chunkId] + ".chunk.js";
};